import { constant } from "./constants"

const axiosConfig = {
    baseURL: constant.API_URL,
    headers :{
        'Accept': 'application/json',
        'Content-Type' : 'application/json'
    }
}

export const axiostToken = {
   token : `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImRhbmcudGhhbmhAbGlmZXRlY2h2bi5uZXQiLCJleHAiOjE3NDA5NjU0OTUsInVzZXJJZCI6ImEzMTE4OGUwLTMzMDEtNGQ2MC1hYWZhLTlkZTIwOTVhYjU4ZiJ9.0Ug3ugliP2954PllMlfSbdK8JmXO5VgATdJKFRNINLs`
}
export default axiosConfig;